import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isSessionActive()) {
    authService.clearAllData();
    router.navigate(['/login']);
    return false;
  }

  return true;
};

export const loginGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isLogout = route.queryParams['logout'] === 'true';

  if (isLogout) {
    authService.clearAllData();
    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(';').forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });

    return true;
  }

  if (authService.isSessionActive()) {
    router.navigate(['/layout']);
    return false;
  }

  return true;
};
